import { collections } from "@/mocks/scandal";

const kindIcon: Record<string, string> = {
  档案: "ri-folder-user-line",
  线索: "ri-vip-diamond-line",
  专题: "ri-focus-3-line",
  核验: "ri-search-eye-line",
  追踪: "ri-radar-line",
};

export default function CollectionIndex() {
  return (
    <section id="collection" className="scroll-mt-24 bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-3xl">
            <p className="flex items-center gap-3 font-label text-xs tracking-[0.3em] text-primary-600 uppercase">
              <span className="inline-block h-px w-8 bg-primary-500" />
              档案馆合集 / ARCHIVE
            </p>
            <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              合集索引：想快速进库，从这里挑
            </h2>
            <p className="mt-3 text-sm leading-6 text-foreground-600 md:text-[15px]">
              每个合集都是一条独立检索入口，按人物、内幕、复盘、核验归档。合集是本库最高频的入口，值得放前面。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4">
          {collections.map((c) => (
            <a
              key={c.name}
              href="#collection"
              className="group relative flex flex-col overflow-hidden rounded-lg border border-foreground-950/6 bg-background-50 p-4 transition-all hover:-translate-y-0.5 hover:border-foreground-950/20 md:p-5"
            >
              <span className="absolute -right-3 -top-3 h-16 w-16 rounded-full bg-accent-100/80 transition-colors group-hover:bg-accent-200" />
              <div className="relative flex items-center justify-between">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 text-background-50">
                  <i className={kindIcon[c.kind] + " text-base"} />
                </span>
                <span className="rounded-full bg-secondary-100 px-2 py-0.5 font-label text-[11px] text-secondary-700">
                  {c.kind}
                </span>
              </div>
              <h3 className="relative mt-4 font-heading text-[15px] font-bold leading-snug text-foreground-950">
                {c.name}
              </h3>
              <p className="relative mt-0.5 font-label text-[10px] tracking-[0.2em] text-foreground-400">{c.en}</p>
              <p className="relative mt-2 line-clamp-2 text-[13px] leading-5 text-foreground-600">{c.desc}</p>
              <div className="relative mt-4 flex items-center justify-between border-t border-foreground-950/6 pt-3">
                <span className="font-heading text-lg font-bold text-accent-700">{c.count}</span>
                <span className="flex items-center gap-1 font-label text-[11px] text-foreground-500">
                  条词条
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}